import { useTranslation } from 'react-i18next';

export default function CTABanner() {
  const { t } = useTranslation();

  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-16 md:py-20 bg-white">
      <div className="max-w-4xl mx-auto text-center">
        <div className="bg-warm-900 rounded-2xl px-6 py-12 md:px-16 md:py-16 relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-brand-900/20 to-transparent" />
          <div className="relative z-10">
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4">
              {t('ctaBanner.h2')}
            </h2>
            <p className="text-sm md:text-base text-warm-300 mb-8 max-w-xl mx-auto">
              {t('ctaBanner.description')}
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="px-6 py-3 bg-brand-600 text-white font-medium rounded-full hover:bg-brand-500 transition-colors whitespace-nowrap"
              >
                {t('ctaBanner.cta')}
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="px-6 py-3 bg-white text-warm-900 font-medium rounded-full hover:bg-warm-100 transition-colors whitespace-nowrap"
              >
                {t('ctaBanner.cta2')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}